import React, { useContext } from "react";
import { OrdersContext } from "../../context/OrdersContext";
import { Select, Card, Col, Row, DatePicker } from "antd";
import { statusList } from "../../utils";
import { TopLocations } from "./components/Marketing/TopLocations";
import { TopCategoryChannelPaymenttype } from "./components/Marketing/TopCategoryChannelPaymenttype";
import { ClientTable } from "./components/Marketing/ClientTable";
import { TopClientsTable } from "./components/Marketing/TopClientsTable";
import { CardStatisticMarketing } from "./components/Marketing/CardStatisticMarketing";
const { Option } = Select;

const { RangePicker } = DatePicker;
const dateFormat = "DD-MM-YYYY";

const statusOptions = statusList ? Object.keys(statusList) : [];

export const BoardMarketing = () => {

  const {
    statusFilter,
    dateFilter,
    isLoadingSales,
    isLoadingOrders,
    setStatusFilter,
    filteredOrdersByStart,
    filteredOrdersByEnd,
    setDateFilter, } = useContext(OrdersContext);

  const totalOrders = filteredOrdersByStart?.length;
  const deliveredOrders = filteredOrdersByStart?.filter(
    (order) => order.status === "Entregado"
  )?.length;
  const conversionRate = ((deliveredOrders / totalOrders) * 100)?.toFixed(2);

  const isLoading = isLoadingSales || isLoadingOrders;

  if (isLoading) {
    return (
      <div style={{ marginTop: 40, marginLeft: 20 }}>Cargando Marketing...</div>
    );
  } else {
    return (
      <div className="flex justify-center h-fit">
        <div className="grid-rows-custom grid-cols-custom gap-x-0 gap-y-0 m-5 w-full xl:w-11/12">
          <div>
            <div
            className="flex justify-end"
            >
              <div className="mr-5 w-80 pb-4">
                <RangePicker
                  value={dateFilter}
                  onChange={(dates) => setDateFilter(dates)}
                  format={dateFormat}
                />
              </div>
              <div>
                <Select
                  mode="multiple"
                  value={
                    statusFilter?.length ? statusFilter : ["Todos los estados"]
                  }
                  onChange={(value) => {
                    if (
                      value.includes("Todos los estados") &&
                      statusFilter?.length === 1
                    ) {
                      setStatusFilter(["Todos los estados"]);
                    } else {
                      setStatusFilter(
                        value.filter((item) => item !== "Todos los estados")
                      );
                    }
                  }}
                  style={{ minWidth: 200 }}
                >
                  <Option disabled value="Todos los estados">
                    Todos los estados
                  </Option>
                  {statusOptions?.map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="">
          <Row gutter={16} className="flex flex-col lg:flex-row">
              <CardStatisticMarketing data={filteredOrdersByStart} totalOrders={totalOrders} deliveredOrders={deliveredOrders} conversionRate={conversionRate}/>
               <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <Card title="Clientes por estado" bordered={true} cover={<ClientTable data={filteredOrdersByEnd} />}/>
              </Col>
               <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <Card title="Clientes top" bodyStyle={{ display: "none" }} bordered={true} cover={ <TopClientsTable data={filteredOrdersByEnd} />}>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="">
          <Row gutter={16} className="flex flex-col lg:flex-row">
               <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <Card bordered={true} cover={<TopLocations data={filteredOrdersByStart} />}/>
              </Col>
               <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <Card bordered={true} cover={<TopCategoryChannelPaymenttype data={filteredOrdersByStart} />}/>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
};
